import React, { FC } from 'react';
import styles from '../journey-explorer.module.scss';
import { JourneyDateRange } from '../../../../models/journey-explorer/journey-explorer';
import { isSameRange } from '../journey-explorer-utils';
import DateField from './date-field';

interface DateRangeProps {
	title: string;
	range: JourneyDateRange;
	limits: JourneyDateRange;
	color: string;
	onChange: (range: JourneyDateRange) => void;
}

const DateRange: FC<DateRangeProps> = ({ title, range, limits, color, onChange }) => {
	const changed = !isSameRange(range, limits);

	return (
		<div className={styles.date_range} style={{ borderLeftColor: changed ? color : 'transparent' }}>
			<div className={styles.date_range_header}>
				<span className={styles.date_range_title}>{title}</span>
				{changed && (
					<button type="button" className={styles.link} onClick={() => onChange(limits)}>
						Reset
					</button>
				)}
			</div>
			<div className={styles.date_inputs}>
				<DateField
					label={`${title} start`}
					value={range.from}
					min={limits.from}
					max={range.to}
					fallback={limits.from}
					onChange={(from) => onChange({ ...range, from })}
				/>
				<span className={styles.date_separator} aria-hidden="true">
					–
				</span>
				<DateField
					label={`${title} end`}
					value={range.to}
					min={range.from}
					max={limits.to}
					fallback={limits.to}
					onChange={(to) => onChange({ ...range, to })}
				/>
			</div>
		</div>
	);
};

export default DateRange;
